import {useCallback, useState} from "react";

// useTelegramPayments инкапсулирует оплату через Telegram WebApp invoices.
export const useTelegramPayments = () => {
    const [isProcessing, setIsProcessing] = useState(false);

    const isPaymentSupported = useCallback(() => {
        const webApp = window.Telegram?.WebApp;
        if (!webApp?.openInvoice) {
            return false;
        }
        if (typeof webApp.isVersionAtLeast !== "function") {
            return true;
        }
        return webApp.isVersionAtLeast("6.1");
    }, []);

    const initiatePurchase = useCallback((invoiceLink) => {
        return new Promise((resolve, reject) => {
            if (!isPaymentSupported()) {
                reject(new Error("Telegram Stars are not supported in this client"));
                return;
            }

            if (!invoiceLink || typeof invoiceLink !== "string") {
                reject(new Error("Invalid invoice link"));
                return;
            }

            setIsProcessing(true);
            window.Telegram.WebApp.openInvoice(invoiceLink, (status) => {
                setIsProcessing(false);

                if (status === "paid") {
                    resolve({success: true, status});
                    return;
                }

                if (status === "cancelled") {
                    reject(new Error("Payment cancelled by user"));
                    return;
                }

                reject(new Error("Payment failed"));
            });
        });
    }, [isPaymentSupported]);

    return {
        isProcessing,
        isPaymentSupported,
        initiatePurchase,
    };
};
